// src/components/About.js
import React, { useEffect, useContext, useState } from "react";
import "../../css/MyPropertyValuation.css";
import { AppContext } from "../../context/AppContext";
import axios from "axios";
import config from "../../config/config";
import StatusAccordion from "./StatusAccordian";
import ConfirmationModal from "../modals/ConfirmationModal";

const MyPropertyValuation = () => {
  const token = config.getAuthToken();
  const { user } = useContext(AppContext);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [msgTitle, setMsgTitle] = useState("");
  const [message, setMessage] = useState("");
  const [icon, setIcon] = useState("");
  const [theme, setTheme] = useState("");

  const [data, setData] = useState([]);
  const getValuation = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/myPropertyValuation/${user?.data?.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Attach Bearer token
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setData(response.data.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response) {
        if (error.response.status === 404) {
          setShowConfirmModal(true);
          setMsgTitle(
            "No properties valuation status found for this user."
          );
          setMessage();
          setIcon("fa fa-info-circle");
          setTheme("gold");
        } else {
          setShowConfirmModal(true);
          setMsgTitle("Failed to fetch data. Please try again.");
          setMessage();
          setIcon("fa fa-times-circle-o");
          setTheme("red");
        }
      }
    }
  };
  useEffect(() => {
    getValuation();
  }, [user?.data?.id]);
  return (
    <>
      <div className="nofltrbx">
        <div className="title-header breadcrumb">
          <div className="profile-path">
            <span>My Property Valuation</span>
            <span className="propcount">({data?.length})</span>
          </div>
        </div>
      </div>

      <div className="allmsgs mypropval">
        <div class="accordion" id="accordionExample">
          {data?.length > 0 ? (
            data.map((item, index) => {
              return <StatusAccordion data={item} />;
            })
          ) : (
            <p>No data available</p>
          )}
        </div>
      </div>
      {showConfirmModal && (
        <ConfirmationModal
          onClose={() => setShowConfirmModal(false)}
          title={msgTitle}
          message={message}
          icon={icon}
          theme={theme}
        />
      )}
    </>
  );
};

export default MyPropertyValuation;
